// extracted by mini-css-extract-plugin
export var button = "Button-module--button--f439e";
export var large = "Button-module--large--0845c";
export var medium = "Button-module--medium--1e4f9";
export var paragraph = "Button-module--paragraph--01159";
export var paragraphSm = "Button-module--paragraph-sm--5284c";
export var paragraphXs = "Button-module--paragraph-xs--a28be";
export var primary = "Button-module--primary--66290";
export var radius2Xl = "Button-module--radius-2xl--d9ffe";
export var radiusFull = "Button-module--radius-full--4221f";
export var radiusLg = "Button-module--radius-lg--0216e";
export var radiusMd = "Button-module--radius-md--fb0f1";
export var radiusSm = "Button-module--radius-sm--5b3e4";
export var radiusXl = "Button-module--radius-xl--1c4f5";
export var radiusXs = "Button-module--radius-xs--0b485";
export var secondary = "Button-module--secondary--02dda";
export var small = "Button-module--small--07354";
export var titleH1 = "Button-module--title-h1--59625";
export var titleH2 = "Button-module--title-h2--f0fe2";
export var titleH3 = "Button-module--title-h3--fdcb4";
export var titleH3Alt = "Button-module--title-h3--alt--9bb54";
export var titleH4 = "Button-module--title-h4--f9daf";
export var titleH5 = "Button-module--title-h5--974f4";
export var xs = "Button-module--xs--7c5ab";